/**
 * House of Places — "All posters" search + Shop link.
 *
 * HOP (2026-10-26):
 * 1) Header "Shop" (desktop mega-menu summary with data-hop-shop-url) goes
 *    straight to /collections/all instead of opening the country panel.
 * 2) On /collections/all a search box sits centred above the grid. Typing
 *    "austin" swaps the grid for the Austin posters (title search through
 *    /search, same card markup). Clearing it restores the full grid.
 *    ?q=austin (or ?city=austin, used by the map pins) runs it on load.
 * Loaded from snippets/hop-cart-bubble.liquid.
 */
(function () {
  if (window.__hopCollectionSearch) return;
  window.__hopCollectionSearch = true;

  // ---- 1) Shop → All posters -------------------------------------------
  document.addEventListener(
    'click',
    function (e) {
      var s = e.target.closest && e.target.closest('summary[data-hop-shop-url]');
      if (!s || e.button !== 0) return;
      e.preventDefault();
      e.stopPropagation();
      var url = s.getAttribute('data-hop-shop-url') || '/collections/all';
      if (e.metaKey || e.ctrlKey) window.open(url, '_blank');
      else window.location.href = url;
    },
    true
  );

  // ---- 2) Search on /collections/all -------------------------------------
  if (!/^\/collections\/all\/?$/.test(window.location.pathname)) return;

  function start() {
    var container = document.getElementById('ProductGridContainer');
    if (!document.querySelector('ul#product-grid') || !container || document.getElementById('hop-cs')) return;
    // Dawn re-renders the grid when filters/sort change, so always look it up.
    function getGrid() { return document.querySelector('ul#product-grid'); }
    var searching = false;

    var PER_PAGE = 24;
    var MAX_PAGES = 8;
    var originalHTML = getGrid().innerHTML;
    var section = container.closest('.shopify-section') || container.parentNode;
    // While searching: hide the filter sidebar, the sort/count bar and the
    // pagination, so the results use the full width.
    var hideWhileSearching = [
      section.querySelector('#main-collection-filters, aside.facets-wrapper'),
      container.querySelector('facet-filters-form'),
      section.querySelector('.pagination-wrapper'),
    ].filter(Boolean);

    var css =
      '#hop-cs{width:100%;max-width:640px;margin:2.4rem auto 2.8rem;padding:0 1.6rem;text-align:center}' +
      '#hop-cs .hop-cs__box{position:relative;display:flex;align-items:center}' +
      '#hop-cs svg{position:absolute;left:1.8rem;width:2rem;height:2rem;opacity:.6;pointer-events:none}' +
      '#hop-cs input{width:100%;font:inherit;font-size:1.7rem;padding:1.4rem 4.8rem 1.4rem 5rem;border:1.5px solid rgba(var(--color-foreground),.35);' +
      'border-radius:999px;background:rgb(var(--color-background));color:rgb(var(--color-foreground));outline:none;box-shadow:0 2px 10px rgba(0,0,0,.05);-webkit-appearance:none}' +
      '#hop-cs input:focus{border-color:rgb(var(--color-foreground));box-shadow:0 2px 14px rgba(0,0,0,.09)}' +
      '#hop-cs input::-webkit-search-cancel-button{display:none}' +
      '#hop-cs .hop-cs__clear{position:absolute;right:1.2rem;width:3.2rem;height:3.2rem;border:0;border-radius:50%;background:none;cursor:pointer;font-size:2rem;line-height:1;color:rgb(var(--color-foreground));opacity:.6}' +
      '#hop-cs .hop-cs__clear:hover{opacity:1}' +
      '#hop-cs .hop-cs__status{min-height:2.2rem;margin-top:1rem;font-size:1.4rem;opacity:.75}' +
      '#hop-cs .hop-cs__status a{color:inherit}' +
      '.hop-cs-loading #product-grid{opacity:.45;transition:opacity .15s}' +
      '@media (max-width:749px){#hop-cs{margin:1.6rem auto 2rem}#hop-cs input{font-size:16px}}';
    var style = document.createElement('style');
    style.textContent = css;
    document.head.appendChild(style);

    var wrap = document.createElement('div');
    wrap.id = 'hop-cs';
    wrap.innerHTML =
      '<form class="hop-cs__box" role="search" action="/search">' +
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/></svg>' +
      '<input type="search" name="q" autocomplete="off" aria-label="Search posters" placeholder="Search a city, country or place — e.g. Austin">' +
      '<button type="button" class="hop-cs__clear" aria-label="Clear search" hidden>×</button>' +
      '</form>' +
      '<div class="hop-cs__status" aria-live="polite"></div>';
    // Centred above the sidebar + grid row (not inside the sidebar).
    var anchor = section.querySelector('.facets-vertical, .facets-wrapper') || container;
    anchor.parentNode.insertBefore(wrap, anchor);

    // The banner text used to point at the sidebar search.
    var desc = document.querySelector('.collection-hero__description');
    if (desc && /on the left/i.test(desc.textContent)) {
      desc.innerHTML = desc.innerHTML.replace(/Search a city on the left to browse listings\.?/i, 'Search any city or place below to find its posters.');
    }

    var input = wrap.querySelector('input');
    var clearBtn = wrap.querySelector('.hop-cs__clear');
    var status = wrap.querySelector('.hop-cs__status');
    var timer = null;
    var token = 0;

    function esc(s) {
      return s.replace(/[&<>"]/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
      });
    }

    function setUrl(q) {
      try {
        var u = new URL(window.location.href);
        u.searchParams.delete('city');
        if (q) u.searchParams.set('q', q);
        else u.searchParams.delete('q');
        history.replaceState(history.state, '', u.toString());
      } catch (e) {}
    }

    function fetchPage(q, page) {
      var url = '/search?type=product&options%5Bprefix%5D=last&page=' + page + '&q=' + encodeURIComponent(q);
      return fetch(url, { credentials: 'same-origin' })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var d = new DOMParser().parseFromString(html, 'text/html');
          var countEl = d.querySelector('[id*="ProductCount"]');
          var count = countEl ? parseInt(countEl.textContent.replace(/[^\d]/g, ''), 10) : NaN;
          return { items: [].slice.call(d.querySelectorAll('#product-grid li.grid__item')), count: count };
        });
    }

    function fetchAll(q) {
      return fetchPage(q, 1).then(function (first) {
        var total = isNaN(first.count) ? first.items.length : first.count;
        var pages = Math.min(MAX_PAGES, Math.ceil(total / PER_PAGE));
        var rest = [];
        for (var p = 2; p <= pages; p++) rest.push(fetchPage(q, p));
        return Promise.all(rest).then(function (more) {
          var items = first.items;
          more.forEach(function (m) { items = items.concat(m.items); });
          return { items: items, total: total };
        });
      });
    }

    function restore() {
      token++;
      document.documentElement.classList.remove('hop-cs-loading');
      if (searching) getGrid().innerHTML = originalHTML;
      searching = false;
      hideWhileSearching.forEach(function (el) { el.style.display = ''; });
      status.textContent = '';
      clearBtn.hidden = true;
      setUrl('');
    }

    function run(raw) {
      var q = (raw || '').trim();
      clearBtn.hidden = !q;
      if (q.length < 2) {
        if (!q) restore();
        return;
      }
      var my = ++token;
      var words = q.toLowerCase().replace(/[:()"*]/g, ' ').split(/\s+/).filter(Boolean);
      var titleQuery = words.map(function (w) { return 'title:' + w; }).join(' ');
      document.documentElement.classList.add('hop-cs-loading');
      status.textContent = 'Searching…';

      fetchAll(titleQuery)
        .then(function (res) { return res.items.length ? res : fetchAll(words.join(' ')); })
        .then(function (res) {
          if (my !== token) return;
          document.documentElement.classList.remove('hop-cs-loading');
          hideWhileSearching.forEach(function (el) { el.style.display = 'none'; });
          var grid = getGrid();
          if (!searching) originalHTML = grid.innerHTML;
          searching = true;
          grid.innerHTML = '';
          res.items.forEach(function (li) {
            li.classList.remove('scroll-trigger', 'animate--slide', 'scroll-trigger--offscreen');
            [].forEach.call(li.querySelectorAll('.scroll-trigger'), function (el) {
              el.classList.remove('scroll-trigger', 'animate--slide', 'scroll-trigger--offscreen');
            });
            grid.appendChild(document.importNode(li, true));
          });
          setUrl(q);
          if (!res.items.length) {
            status.innerHTML = 'No posters found for “' + esc(q) + '”. <a href="/pages/contact">Request this place</a>';
          } else {
            var shown = res.items.length;
            var more = res.total > MAX_PAGES * PER_PAGE ? ' (showing the first ' + shown + ')' : '';
            status.innerHTML =
              shown + (shown === 1 ? ' poster' : ' posters') + ' for “' + esc(q) + '”' + more +
              ' · <a href="#" data-hop-cs-clear>Show all posters</a>';
          }
        })
        .catch(function () {
          if (my !== token) return;
          document.documentElement.classList.remove('hop-cs-loading');
          status.textContent = 'Search is unavailable right now — please try again.';
        });
    }

    input.addEventListener('input', function () {
      clearTimeout(timer);
      timer = setTimeout(function () { run(input.value); }, 300);
    });
    wrap.querySelector('form').addEventListener('submit', function (e) {
      e.preventDefault();
      clearTimeout(timer);
      run(input.value);
      input.blur();
    });
    clearBtn.addEventListener('click', function () {
      input.value = '';
      restore();
      input.focus();
    });
    status.addEventListener('click', function (e) {
      if (!e.target.closest('[data-hop-cs-clear]')) return;
      e.preventDefault();
      input.value = '';
      restore();
    });

    var params = new URLSearchParams(window.location.search);
    var initial = params.get('q') || params.get('city');
    if (initial) {
      input.value = initial;
      run(initial);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
